import React from 'react';
import SettingsValueCard from './settings-value-card';
import DragDropFields from './drag-frop-fields';
const PipelineDisplaySettings = () => {
  return (
    <div className="settings--values">
      <SettingsValueCard
        title={'Pipeline cards'}
        description={'This is how I want pipeline data to appear on listings and task cards:'}
      >
        <DragDropFields text={'pipeline'} />
      </SettingsValueCard>
    </div>
  );
};

export default PipelineDisplaySettings;
